'use client';
import HeroPrimary from "@/components/sections/hero-banners/HeroPrimary";
import ProductsPrimary from "@/components/sections/products/ProductsPrimary";
import {useTranslations} from 'next-intl';
import {useState} from 'react';

export default function ShopMain({ home, socialLinks, query, products, currency, options, categories, brands, isMobile, background }) {
  const t = useTranslations('catalog');
  let queryParam = null;
  let queryParams = [];
  if (!!query.search) {
    queryParam = {
      title: query.search,
      queryParam: 'search'
    };
    queryParams.push({
      title: query.search,
      queryParam: 'search'
    });
  }
  if ((!!query.category || !!query.subcategory) && query.title) {
    queryParam = {
      title: query.title,
      queryParam: 'category'
    };
    queryParams.push({
      title: query.title,
      queryParam: 'category'
    });
  }
  if (!!query.brand && query.title) {
    queryParam = {
      title: query.title,
      queryParam: 'brand'
    };
    queryParams.push({
      title: query.title,
      queryParam: 'brand'
    });
  }
  if (!!query.tag) {
    const trTitle = t(`productSectionTags.${query.tag.toUpperCase()}`);
    queryParam = {
      title: trTitle,
      queryParam: 'tag'
    };
    queryParams.push({
      title: trTitle,
      queryParam: 'tag'
    });
  }
  
  const [heroTitle, setHeroTitle] = useState(queryParam ?? t('catalog'));

  return (
    <main>
      <HeroPrimary
          title={heroTitle || t('catalog')}
          text={t('catalog')}
          type={3}
          background={background}
      />
      <ProductsPrimary
          home={home}
          socialLinks={socialLinks}
          products={products}
          options={options}
          currency={currency}
          categories={categories}
          queryParams={queryParams}
          brands={brands}
          setHeroTitle={setHeroTitle}
          isMobile={isMobile}
      />
    </main>
  );
};
